import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
}

export default function Card({
  children,
  className = '',
  padding = 'md',
  hover = false,
}: CardProps) {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const hoverClass = hover ? 'hover:shadow-lg transition-all dark:hover:border-vivid-cyan-bright/50' : '';

  return (
    <div
      className={`bg-white dark:bg-metallic-900 dark:border-2 dark:border-vivid-purple-dark/30 rounded-lg shadow dark:shadow-metallic-950/50 ${paddingClasses[padding]} ${hoverClass} ${className}`}
    >
      {children}
    </div>
  );
}

// Made with Bob
